<template>
  <div class="all-table-class">
    <el-table
      ref="multipleTable"
      :data="relTableData"
      :height="tableHeight"
      tooltip-effect="dark"
      @selection-change="selectionChange"
      @row-click="rowClick"
      @row-dblclick="rowDblclick"
      row-key="code"
      :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
      :style="{width: tableWidth}">
      <el-table-column
        type="selection"
        v-if="selection"
        width="55">
      </el-table-column>
      <el-table-column
        type="expand"
        v-if="item.hasExpand"
        v-for="(item, tableIndex)
        in tableHead"
        :key="item.label"
        :prop="item.prop"
        :label="item.label"
        :width="item.width">
        <template slot-scope="scope">
          <div class="housing-allocation-box">
            <div class="housing-allocation-box-top" v-if="scope.row.yqAppCode == 'dllss'">
              <button-confirm value="分配房源" @confirm="allocateListings(scope.row)"/>
            </div>
            <el-empty description="暂无房源" v-if="scope.row[item.prop].length === 0"></el-empty>
            <div v-else class="housing-allocation-line">
              <div class="housing-allocation-item" v-for="item in scope.row[item.prop]">
                <div class="housing-allocation-item-title">
                  <div class="housing-allocation-item-label">{{ item.leaseRoomNumberLabel }}</div>
                  <div class="housing-allocation-item-area" v-if="scope.row.yqAppCode == 'dllss'">
                    <i class="el-icon-damai-bianji" @click="modifyListingsRow(item)"></i>
                    <i class="el-icon-damai-ic_shanchu1" @click="deleteListingRow(item)"></i>
                  </div>
                </div>
                <div class="housing-allocation-item-info">
                  <div class="housing-allocation-item-info-line">
                    <i class="el-icon-damai-ic_zujinguanli"></i>
                    <div class="housing-allocation-item-info-line-main">{{ item.price }}元</div>
                  </div>
                  <div class="housing-allocation-item-info-line">
                    <i class="el-icon-damai-ic_wuzileimu"></i>
                    <div class="housing-allocation-item-info-line-main">{{ item.roomType }} {{ item.roomArea }}m²</div>
                  </div>
                  <div class="housing-allocation-item-info-line">
                    <i class="el-icon-damai-kalendar"></i>
                    <div class="housing-allocation-item-info-line-main">
                      {{ item.leaseStartTime }}至{{ item.leaseStopTime }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item, tableIndex) in tableHead"
        :key="item.label"
        :prop="item.prop"
        :label="item.label"
        :width="item.width"
        v-if="!item.hasExpand">
        <template slot-scope="scope">
          <span
            v-if="item.example"
            style="cursor: pointer;color: #1362FF;"
            @click="seeExample(scope.row)"
          >查看</span>
          <span v-else-if="item.isPic">
            <span v-if="scope.row.yqPicUrl.indexOf('http') === -1">--</span>
            <el-popover placement="top" width="160" trigger="hover" offset="60" v-else>
              <a slot="reference" style="color: #1362FF">预览</a>
              <img
                :src="scope.row.yqPicUrl"
                style="display: block;width: 120px;height: 160px; margin: 0 auto;"
              >
            </el-popover>
          </span>
          <span v-else-if="item.isPreviewPic">
            <span v-if="scope.row[item.prop].indexOf('http') === -1">--</span>
            <el-popover
              placement="top"
              width="160"
              trigger="hover"
              offset="60"
              v-else>
              <a slot="reference" style="color: #1362FF">预览</a>
              <img
                :src="scope.row[item.prop]"
                style="display: block;width: 120px;height: auto; margin: 0 auto;"
              >
            </el-popover>
          </span>
          <span v-else-if="item.isPreviewPic2">
            <span v-if="scope.row[item.prop].indexOf('http') === -1">--</span>
            <div
              v-else
              style="color: #1362FF;"
              @click="lookOver2(scope.row[item.prop])"
            >查看
            </div>
          </span>
          <div v-else-if="item.isStatus">
            <div
              style="background-color: #F56C6C;width: 15px;height: 15px;border-radius: 50%;margin: 0 auto;"
              v-if="scope.row[item.prop] === '0'"
            ></div>
            <div
              style="background-color: #67C23A;width: 15px;height: 15px;border-radius: 50%;margin: 0 auto;"
              v-else-if="scope.row[item.prop] === '1'"
            ></div>
          </div>
          <div v-else-if="item.isStatusHasExplain">
            <el-popover
              placement="top-start"
              title="异常说明"
              width="200"
              trigger="hover"
              :content="scope.row[item.explain]"
              v-if="scope.row[item.prop] === '0'">
              <div
                slot="reference"
                style="background-color: #F56C6C;width: 15px;height: 15px;border-radius: 50%;margin: 0 auto;">
              </div>
            </el-popover>
            <div
              style="background-color: #67C23A;width: 15px;height: 15px;border-radius: 50%;margin: 0 auto;"
              v-else-if="scope.row[item.prop] === '1'">
            </div>
          </div>
          <div v-else-if="item.isLooking">
            <div style="color: #1362FF;" v-if="!scope.row">--</div>
            <div
              v-else
              style="color: #1362FF;cursor: pointer;"
              @click="lookOver(scope.row)"
            >查看
            </div>
          </div>
          <div v-else-if="item.downloadOrUpdateFile">
            <div style="color: #1362FF;" v-if="scope.row[item.prop].indexOf('http') === -1">
              <el-upload
                :action="actionUrl"
                :headers="scope.row[item.uploadHeaders]"
                :on-success="uploadContractSuccess"
                :on-error="uploadContractError"
                :limit="1">
                <span style="color: #1362FF;cursor: pointer;" @click="changeDownloadOrUpdateFile(scope.row)">上传</span>
              </el-upload>
            </div>
            <div
              v-else
              style="color: #1362FF;"
              @click="downloadOrUpdateFile(scope.row)"
            >查看
            </div>
          </div>
          <div v-else-if="item.enclosure">
            <div style="color: #1362FF;" v-if="scope.row[item.prop].indexOf('http') === -1">
              <el-upload
                :action="actionUrl"
                :headers="scope.row[item.uploadHeaders]"
                :on-success="uploadEnclosureSuccess"
                :on-error="uploadEnclosureError"
                :limit="1">
                <span
                  style="color: #1362FF;cursor: pointer;"
                  @click="changeDownloadOrUpdateFile(scope.row)"
                >上传
                </span>
              </el-upload>
            </div>
            <div
              v-else
              style="color: #1362FF;"
              @click="downloadOrUpdateEnclosureFile(scope.row)"
            >查看
            </div>
          </div>

          <div v-else-if="item.downloadAppendix">
            <div
              style="color: #1362FF;"
              @click="downloadAppendix(scope.row[item.prop])"
              v-if="scope.row[item.prop]"
            >下载
            </div>
            <div v-else>无</div>
          </div>
          <div v-else-if="item.isLookingImg">
            <div style="color: #1362FF;" v-if="!scope.row">--</div>
            <div
              style="color: #1362FF;"
              v-else
              @click="lookOverImg(scope.row[item.isLookingImgUrl])">
              <span v-if="item.isLookingText">{{ scope.row[item.prop] }}</span>
              <span v-else>查看</span>
            </div>
          </div>
          <div v-else-if="item.exhibition">
            <div style="color: #1362FF;" v-if="!scope.row">--</div>
            <div style="color: #1362FF;" v-else>
              <span
                v-if="scope.row[item.prop]=='0'"
                style="color:#000">
                {{ scope.row[item.prop] }}
              </span>
              <span
                v-else
                @click="exhibition(scope.row,scope.column.property)"
                style="cursor:pointer">
                {{ scope.row[item.prop] }}
              </span>
            </div>
          </div>
          <div v-else-if="item.isLookOver">
            <span v-if="scope.row[item.prop].indexOf('http') === -1">--</span>
            <div
              v-else
              style="color: #1362FF;"
              @click="lookOver(scope.row[item.prop])"
            >查看
            </div>
          </div>
          <el-switch
            v-else-if="item.isSwitch"
            v-model="scope.row[item.prop]"
            @change="changeSwitch(scope.row)"
            :active-text="item.active || '是'"
            :inactive-text="item.inactive || '否'">
          </el-switch>
          <el-switch
            v-else-if="item.isSwitch2"
            v-model="scope.row[item.prop]"
            @change="changeSwitch2(scope.row)"
            :active-text="item.active || '是'"
            :inactive-text="item.inactive || '否'">
          </el-switch>
          <div v-else-if="item.closeInventory">
            <el-button
              type="info"
              size="small"
              v-if="scope.row.finished===true"
              style="width:92px">
              已关闭
            </el-button>
            <el-button
              type="primary"
              @click="closeInventory(scope.row)"
              size="small"
              v-else style="width:92px">
              关闭此盘点
            </el-button>
          </div>
          <div v-else-if="item.closeQuestionnaire">
            <el-button
              type="primary"
              @click="closeQuestionnaire(scope.row)"
              size="small"
              v-if="scope.row.status==='1'"
              style="width:92px">
              下线此问卷
            </el-button>
            <el-button
              type="info"
              size="small"
              v-else
              style="width:92px">
              已下线
            </el-button>
          </div>
          <el-select
            v-else-if="item.changeStatus"
            v-model="scope.row[item.prop]"
            size="mini"
            style="width: 100px"
            :disabled="scope.row[item.statusOnPageChangeStatus]"
            @change="statusChange">
            <el-option
              v-for="status in item.statusList"
              :key="status.code"
              :label="status.name"
              :value="status.code"
              :disabled="status.disabled">
            </el-option>
          </el-select>
          <el-input
            v-else-if="item.changeInfo"
            v-model="scope.row[item.prop]"
            size="mini"
            style="width: 160px"
            :disabled="scope.row[item.statusOnPageChangeStatus] || scope.row[item.statusAlreadyOnPageChangeStatus] !== '1'"
            @keyup.enter.native="statusInfoChange"
            @blur="statusInfoChange"/>
          <div v-else-if="item.changeInput" @dblclick="wantChangeInput(scope.row,scope.column.property)">
            <el-tooltip class="item" effect="dark" content="双击可修改,回车确认修改" placement="top">
              <el-input
                v-model="scope.row[item.prop]"
                size="mini"
                style="width: 160px;"
                :disabled="scope.row.changeInputDisabled"
                @keyup.enter.native="changeInputChange(scope.row,scope.column.property)"
                @blur="changeInputChange(scope.row,scope.column.property)"/>
            </el-tooltip>
          </div>
          <div v-else-if="item.changeLockInput" @dblclick="wantChangeInput(scope.row,scope.column.property)">
            <el-tooltip class="item" effect="dark" content="双击可修改,回车确认修改" placement="top">
              <el-input
                v-model="scope.row[item.prop]"
                size="mini"
                style="width: 160px;"
                :disabled="scope.row.changePasswordDisabled"
                @blur="changeInputChange(scope.row,scope.column.property)"/>
            </el-tooltip>
          </div>
          <div v-else-if="item.changeLockInput2" @dblclick="wantChangeInput(scope.row,scope.column.property)">
            <el-tooltip
              class="item"
              effect="dark"
              content="双击可修改,回车确认修改"
              placement="top">
              <el-input
                v-model="scope.row[item.prop]"
                size="mini"
                style="width: 160px;"
                :disabled="scope.row.changeCardNumberDisabled"
                @blur="changeInputChange(scope.row,scope.column.property)"/>
            </el-tooltip>
          </div>

          <span
            :title="scope.row[item.prop]"
            v-else-if="item.showColor"
            style="display:inline-block;width:70px;height:28px;border-radius:8px;line-height:28px;"
            :style="{color: item.showColor ? scope.row.fontColorToPeople : null, backgroundColor:item.showColor ? scope.row.backgroundColor : null,}">
            {{ scope.row[item.prop] }}
          </span>
          <span
            :title="scope.row[item.prop]"
            v-else-if="item.showColor2"
            style="display:inline-block;width:70px;height:28px;border-radius:8px;line-height:28px;"
            :style="{color: item.showColor2 ? scope.row.fontColorToPeople2 : null, backgroundColor:item.showColor2 ? scope.row.backgroundColor2 : null,}">
            {{ scope.row[item.prop] }}
          </span>
          <span
            :title="scope.row[item.prop]"
            v-else-if="item.showColor3"
            style="display:inline-block;width:90px;height:28px;border-radius:8px;line-height:28px;"
            :style="{color: item.showColor3 ? scope.row.fontColorToPeople3 : null, backgroundColor:item.showColor3 ? scope.row.backgroundColor3 : null,}">
            {{ scope.row[item.prop] }}
          </span>
          <span
            v-else
            :title="scope.row[item.prop]"
            :style="{color: item.showColor ? scope.row.fontColorToPeople : null, backgroundColor:item.showColor ? scope.row.backgroundColor : null,}">
            {{ scope.row[item.prop] }}
          </span>
        </template>
      </el-table-column>


      <!--      <el-table-column-->
      <!--        v-for="item in tableHead"-->
      <!--        :key="item.label"-->
      <!--        :prop="item.prop"-->
      <!--        :label="item.label"-->
      <!--        v-if="!item.isPic && !item.isStatus && !item.isLooking && !item.isLookOver && !item.isLookingImg && !item.isSwitch && !item.isSwitch2 && !item.changeStatus && !item.changeInfo && !item.isPreviewPic && !item.example"-->
      <!--        :width="item.width">-->
      <!--        <template slot-scope="scope">-->
      <!--          <span :title="scope.row[item.prop]" :style="{color: item.showColor ? scope.row.fontColorToPeople : null}">{{scope.row[item.prop]}}</span>-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <!--      <el-table-column-->
      <!--        v-for="item in tableHead"-->
      <!--        :key="item.label"-->
      <!--        :prop="item.prop"-->
      <!--        :label="item.label"-->
      <!--        v-if="item.example"-->
      <!--        :width="item.width">-->
      <!--        <template slot-scope="scope">-->
      <!--          <span style="cursor: pointer;color: #1362FF;" @click="seeExample(scope.row)">查看</span>-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <!--      <el-table-column-->
      <!--        v-for="item in tableHead"-->
      <!--        :key="item.label"-->
      <!--        :prop="item.prop"-->
      <!--        :label="item.label"-->
      <!--        v-if="item.isPic"-->
      <!--        :width="item.width">-->
      <!--        <template slot-scope="scope">-->
      <!--          <span v-if="scope.row.yqPicUrl.indexOf('http') === -1">&#45;&#45;</span>-->
      <!--          <el-popover-->
      <!--            placement="top"-->
      <!--            width="160"-->
      <!--            trigger="hover"-->
      <!--            offset="60"-->
      <!--            v-else>-->
      <!--            <a slot="reference" style="color: #1362FF">预览</a>-->
      <!--            <img :src="scope.row.yqPicUrl" style="display: block;width: 120px;height: 160px; margin: 0 auto;">-->
      <!--          </el-popover>-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <!--      <el-table-column-->
      <!--        v-for="item in tableHead"-->
      <!--        :key="item.label"-->
      <!--        :prop="item.prop"-->
      <!--        :label="item.label"-->
      <!--        v-if="item.isPreviewPic"-->
      <!--        :width="item.width">-->
      <!--        <template slot-scope="scope">-->
      <!--          <span v-if="scope.row[item.prop].indexOf('http') === -1">&#45;&#45;</span>-->
      <!--          <el-popover-->
      <!--            placement="top"-->
      <!--            width="160"-->
      <!--            trigger="hover"-->
      <!--            offset="60"-->
      <!--            v-else>-->
      <!--            <a slot="reference" style="color: #1362FF">预览</a>-->
      <!--            <img :src="scope.row[item.prop]" style="display: block;width: 120px;height: auto; margin: 0 auto;">-->
      <!--          </el-popover>-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <!--      <el-table-column-->
      <!--        v-for="item in tableHead"-->
      <!--        :key="item.label"-->
      <!--        :prop="item.prop"-->
      <!--        :label="item.label"-->
      <!--        v-if="item.isStatus"-->
      <!--        :width="item.width">-->
      <!--        <template slot-scope="scope">-->
      <!--          <div style="background-color: #F56C6C;width: 15px;height: 15px;border-radius: 50%;margin: 0 auto;" v-if="scope.row[item.prop] === '0'"></div>-->
      <!--          <div style="background-color: #67C23A;width: 15px;height: 15px;border-radius: 50%;margin: 0 auto;" v-else-if="scope.row[item.prop] === '1'"></div>-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <!--      <el-table-column-->
      <!--        v-for="item in tableHead"-->
      <!--        :key="item.label"-->
      <!--        :prop="item.prop"-->
      <!--        :label="item.label"-->
      <!--        v-if="item.isLooking"-->
      <!--        :width="item.width">-->
      <!--        <template slot-scope="scope">-->
      <!--          <div style="color: #1362FF;" v-if="!scope.row">&#45;&#45;</div>-->
      <!--          <div style="color: #1362FF;" v-else @click="lookOver(scope.row)">查看</div>-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <!--      <el-table-column-->
      <!--        v-for="item in tableHead"-->
      <!--        :key="item.label"-->
      <!--        :prop="item.prop"-->
      <!--        :label="item.label"-->
      <!--        v-if="item.isLookingImg"-->
      <!--        :width="item.width">-->
      <!--        <template slot-scope="scope">-->
      <!--          <div style="color: #1362FF;" v-if="!scope.row">&#45;&#45;</div>-->
      <!--          <div style="color: #1362FF;" v-else @click="lookOverImg(scope.row[item.isLookingImgUrl])">-->
      <!--            <span v-if="item.isLookingText">{{scope.row[item.prop]}}</span>-->
      <!--            <span v-else>查看</span>-->
      <!--          </div>-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <!--      <el-table-column-->
      <!--        v-for="item in tableHead"-->
      <!--        :key="item.label"-->
      <!--        :prop="item.prop"-->
      <!--        :label="item.label"-->
      <!--        v-if="item.isLookOver"-->
      <!--        :width="item.width">-->
      <!--        <template slot-scope="scope">-->
      <!--          <span v-if="scope.row[item.prop].indexOf('http') === -1">&#45;&#45;</span>-->
      <!--          <div style="color: #1362FF;" @click="lookOver(scope.row[item.prop])" v-else>查看</div>-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <!--      <el-table-column-->
      <!--        v-for="item in tableHead"-->
      <!--        :key="item.label"-->
      <!--        :prop="item.prop"-->
      <!--        :label="item.label"-->
      <!--        v-if="item.isSwitch"-->
      <!--        :width="item.width">-->
      <!--        <template slot-scope="scope">-->
      <!--          <el-switch-->
      <!--            v-model="scope.row[item.prop]"-->
      <!--            @change="changeSwitch(scope.row)"-->
      <!--            :active-text="item.active || '是'"-->
      <!--            :inactive-text="item.inactive || '否'">-->
      <!--          </el-switch>-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <!--      <el-table-column-->
      <!--        v-for="item in tableHead"-->
      <!--        :key="item.label"-->
      <!--        :prop="item.prop"-->
      <!--        :label="item.label"-->
      <!--        v-if="item.isSwitch2"-->
      <!--        :width="item.width">-->
      <!--        <template slot-scope="scope">-->
      <!--          <el-switch-->
      <!--            v-model="scope.row[item.prop]"-->
      <!--            @change="changeSwitch2(scope.row)"-->
      <!--            :active-text="item.active || '是'"-->
      <!--            :inactive-text="item.inactive || '否'">-->
      <!--          </el-switch>-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <!--      <el-table-column-->
      <!--        v-for="item in tableHead"-->
      <!--        :key="item.label"-->
      <!--        :prop="item.prop"-->
      <!--        :label="item.label"-->
      <!--        v-if="item.changeStatus"-->
      <!--        :width="item.width">-->
      <!--        <template slot-scope="scope">-->
      <!--          <el-select v-model="scope.row[item.prop]" size="mini" style="width: 100px" :disabled="scope.row[item.statusOnPageChangeStatus]" @change="statusChange">-->
      <!--            <el-option v-for="status in item.statusList" :key="status.code"-->
      <!--                       :label="status.name" :value="status.code" :disabled="status.disabled">-->
      <!--            </el-option>-->
      <!--          </el-select>-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <!--      <el-table-column-->
      <!--        v-for="item in tableHead"-->
      <!--        :key="item.label"-->
      <!--        :prop="item.prop"-->
      <!--        :label="item.label"-->
      <!--        v-if="item.changeInfo"-->
      <!--        :width="item.width">-->
      <!--        <template slot-scope="scope">-->
      <!--          <el-input v-model="scope.row[item.prop]" size="mini" style="width: 160px" :disabled="scope.row[item.statusOnPageChangeStatus] || scope.row[item.statusAlreadyOnPageChangeStatus] !== '1'" @keyup.enter.native="statusInfoChange" @blur="statusInfoChange"/>-->
      <!--        </template>-->
      <!--      </el-table-column>-->
      <el-table-column label="操作" :fixed="operationFixed" :width="tableOperationWidth" v-if="hasOperation">
        <template slot-scope="scope">
          <el-button v-if="operationArr.indexOf('faceAuthorization') !== -1" @click="faceAuthorizationRow(scope.row)"
                     type="text" size="small">授权人脸
          </el-button>
          <el-button
            @click="modifyLock(scope.row)"
            type="text"
            size="small"
            v-if="operationArr.indexOf('modifyLock') !== -1"
          >修改
          </el-button>
          <el-button
            @click="quickReportRow(scope.row)"
            type="text"
            size="small"
            v-if="operationArr.indexOf('quickReport') !== -1 && (scope.row.approveNode === '0' && scope.row.approveStatus === '2')"
          >快捷上报
          </el-button>
          <el-button
            v-if="operationArr.indexOf('queryState') !== -1 && (scope.row.approveNode === '1' && scope.row.status === '1')"
            @click="queryStateRow(scope.row)"
            type="text"
            size="small"
          >查询状态
          </el-button>
          <el-button
            v-if="operationArr.indexOf('separateAccounts2') !== -1 && scope.row.parentCode === '0' && scope.row.children.length === 0 && scope.row.payStatus === '0'"
            @click="separateAccountsRow(scope.row)"
            type="text"
            size="small"
          >分账
          </el-button>
          <el-button
            @click="viewInventoryListRow(scope.row.code)"
            type="text"
            v-if="operationArr.indexOf('viewInventoryList') !== -1"
            size="small"
          >查看盘点列表
          </el-button>
          <el-button
            @click="viewInventoryReportRow(scope.row.code)"
            type="text"
            v-if="operationArr.indexOf('viewInventoryReport') !== -1"
            size="small"
          >查看盘点报表
          </el-button>
          <el-button
            @click="GenerateReportRow(scope.row.code)"
            type="text"
            v-if="operationArr.indexOf('GenerateReport') !== -1&& scope.row.finished!==true"
            size="small"
          >生成报表
          </el-button>
          <el-button
            @click="dataSummaryRow(scope.row)"
            type="text"
            v-if="operationArr.indexOf('dataSummary') !== -1"
            size="small"
          >查看数据汇总
          </el-button>
          <el-button
            @click="sendMessageRow(scope.row)"
            type="text"
            v-if="operationArr.indexOf('sendMessage') !== -1"
            size="small"
          >发送消息
          </el-button>
          <el-button
            @click="previewRow(scope.row.code)"
            type="text"
            v-if="operationArr.indexOf('preview') !== -1"
            size="small"
          >预览
          </el-button>
          <el-button
            @click="downloadRow(scope.row.code)"
            type="text"
            v-if="operationArr.indexOf('download') !== -1"
            size="small"
          >下载
          </el-button>
          <el-button
            @click="currentRow(scope.row.code)"
            type="text"
            v-if="operationArr.indexOf('current') !== -1"
            size="small"
          >查看
          </el-button>
          <el-button @click="getTemporaryQRCode(scope.row)" type="text" size="small"
                     v-if="operationArr.indexOf('temporaryQRCode') !== -1 && scope.row.passType !== '1'">收款二维码
          </el-button>
          <el-button @click="getUnlicensedQRCode(scope.row)" type="text" size="small"
                     v-if="operationArr.indexOf('unlicensedQRCode') !== -1 && scope.row.passType == '1'">无牌车进场二维码
          </el-button>
          <el-button
            @click="incubationAgreementRow(scope.row)"
            type="text"
            v-if="operationArr.indexOf('incubationAgreement') !== -1"
            size="small"
          >孵化协议
          </el-button>
          <el-button
            @click="incubatorProjectRow(scope.row)"
            type="text"
            v-if="operationArr.indexOf('incubatorProject') !== -1"
            size="small"
          >孵化计划
          </el-button>
          <el-button
            @click="unbindRoomRow(scope.row.code)"
            type="text"
            v-if="operationArr.indexOf('unbindRoom') !== -1"
            size="small"
          >房源解绑
          </el-button>
          <el-button
            @click="detailsRow(scope.row)"
            type="text"
            v-if="operationArr.indexOf('details') !== -1"
            size="small"
          >查看详情
          </el-button>
          <el-button
            @click="modifyRow(scope.row.code)"
            type="text"
            v-if="operationArr.indexOf('modify') !== -1"
            size="small"
          >修改
          </el-button>
          <el-button
            @click="modifyRow(scope.row.code)"
            v-if="operationArr.indexOf('materialModify') !== -1 && scope.row.finished!==true"
            type="text"
            size="small"
          >修改
          </el-button>
          <el-upload
            :show-file-list="false"
            v-if="operationArr.indexOf('importBill') !== -1"
            ref="uploadSign"
            :action="action"
            :cathUrl="cathUrl"
            :on-success="onSuccess"
            :on-error="uploaderror"
            :headers="upLoadHeader"
            :before-upload="beforeUpload"
            style="display: inline-flex;margin: 0 10px">
            <el-button
              @click="chageSign(scope.row)"
              style="padding:0;font-size: 14px;color: #1362FF;border:0;background: none;"
            >导入缴费名单
            </el-button>
          </el-upload>
          <el-button
            @click="schedulingRow(scope.row)"
            type="text"
            v-if="operationArr.indexOf('scheduling') !== -1"
            size="small"
          >排班调整
          </el-button>
          <el-button
            @click="settlementRow(scope.row)"
            v-if="operationArr.indexOf('settlement') !== -1"
            type="text"
            size="small"
          >结算
          </el-button>
          <el-button
            @click="publishRow(scope.row)"
            v-if="operationArr.indexOf('publish') !== -1"
            type="text"
            size="small"
          >发布
          </el-button>
          <el-button
            @click="deleteRow(scope.row.code)"
            type="text"
            size="small"
            v-if="operationArr.indexOf('delete') !== -1"
          >删除
          </el-button>
          <el-button
            @click="deleteRow(scope.row.code)"
            type="text"
            size="small"
            v-if="(operationArr.indexOf('cardDelete') !== -1) && (scope.row.code.indexOf('A00000000') === -1 && scope.row.code.indexOf('A00000001') === -1 && scope.row.code.indexOf('A00000002') === -1 && scope.row.code.indexOf('A00000003') === -1 && scope.row.code.indexOf('A00000004') === -1)"
          >删除
          </el-button>
          <el-button
            @click="nullifyRow(scope.row)"
            type="text"
            size="small"
            v-if="operationArr.indexOf('nullify') !== -1"
          >作废
          </el-button>
          <el-button
            @click="approveRow(scope.row)"
            type="text"
            size="small"
            v-if="operationArr.indexOf('approve') !== -1"
          >通过
          </el-button>
          <el-button
            @click="unApproveRow(scope.row.code)"
            type="text"
            size="small"
            v-if="operationArr.indexOf('unApprove') !== -1"
          >驳回
          </el-button>
          <el-button
            @click="saveCopyContractRow(scope.row)"
            type="text"
            size="small"
            v-if="operationArr.indexOf('saveCopyContract') !== -1 && scope.row.status === '7'"
          >复制合同
          </el-button>
          <el-button
            @click="manualProcessingRow(scope.row)"
            type="text"
            size="small"
            v-if="operationArr.indexOf('manualProcessing') !== -1 && scope.row.status === '8'"
          >手动处理
          </el-button>
          <qr-popover-box
            v-if="operationArr.indexOf('phone_authorization') !== -1"
            :title="QRTitle"
            :content="scope.row.authUrl"
            :text="QRText"/>
          <el-button
            @click="PCAuth(scope.row.authUrl)"
            type="text"
            size="small"
            v-if="operationArr.indexOf('pc_authorization') !== -1"
          >PC登录授权
          </el-button>
          <el-button
            @click="visitView(scope.row.code)"
            type="text"
            size="small"
            v-if="operationArr.indexOf('visitView') !== -1"
          >查看来访人
          </el-button>
          <el-button
            @click="modifyInvoiceStatus(scope.row)"
            type="text"
            size="small"
            v-if="operationArr.indexOf('modifyInvoiceStatus') !== -1"
          >修改开票状态
          </el-button>
          <el-button
            @click="modifyRow(scope.row.code)"
            type="text"
            size="small"
            v-if="operationArr.indexOf('modifySuggestions') !== -1"
          >查看
          </el-button>
          <el-button
            @click="electricApproveRow(scope.row)"
            type="text"
            size="small"
            v-if="operationArr.indexOf('electricApproveRow') !== -1"
          >通过
          </el-button>
          <el-button
            @click="electricUnApproveRow(scope.row)"
            class="electricUnApprove"
            type="text"
            size="small"
            v-if="operationArr.indexOf('electricUnApproveRow') !== -1"
          >驳回
          </el-button>
          <el-button
            @click="deleteRow(scope.row.code)"
            type="text"
            size="small"
            v-if="operationArr.indexOf('cancelRelease') !== -1"
          >下架
          </el-button>
          <el-button
            @click="getAmmeterTip(scope.row)"
            type="text"
            size="small"
            v-if="operationArr.indexOf('ammeterTip') !== -1"
          >生成标签
          </el-button>
          <el-button
            @click="getDeviceCodeTip(scope.row)"
            type="text"
            size="small"
            v-if="operationArr.indexOf('deviceCodeTip') !== -1"
          >二维码
          </el-button>
          <el-button
            @click="separateAccountsRow(scope.row)"
            type="text"
            size="small"
            v-if="operationArr.indexOf('separateAccounts') !== -1 && scope.row.parentCode === '0' && scope.row.children.length === 0"
          >分账
          </el-button>
          <el-button
            @click="modifyRow(scope.row.code)"
            type="text"
            size="small"
            v-if="operationArr.indexOf('separateAccountsModify') !== -1 && scope.row.children.length === 0"
          >修改
          </el-button>
          <el-button
            @click="invoiceRecordRow(scope.row.serialNo)"
            type="text"
            size="small"
            v-if="operationArr.indexOf('invoiceRecord') !== -1"
          >详情
          </el-button>
          <el-button
            @click="invoiceDetailRow(scope.row.orderNo)"
            type="text"
            size="small"
            v-if="operationArr.indexOf('invoiceDetail') !== -1"
          >详情
          </el-button>
          <el-button
            @click="synchronousRow(scope.row)"
            type="text"
            size="small"
            v-if="
              operationArr.indexOf('synchronous') !== -1 &&
                scope.row.invoiceStatus === 'PENDING'
            "
          >同步
          </el-button>
          <el-button
            @click="syncInvoiceRow(scope.row)"
            type="text"
            size="small"
            v-if="operationArr.indexOf('syncInvoice') !== -1"
          >同步
          </el-button>
          <el-button
            @click="issueReceiptRow(scope.row)"
            type="text"
            size="small"
            v-if="operationArr.indexOf('issueReceipt') !== -1"
          >开具收据
          </el-button>
          <el-button
            @click="showNoticeChoose(scope.row)"
            type="text"
            size="small"
            v-if="operationArr.indexOf('financeNotice') !== -1"
          >通知单
          </el-button>
          <el-button
            @click="previewStream(scope.row)"
            type="text"
            size="small"
            v-if="operationArr.indexOf('previewStream') !== -1"
          >预览
          </el-button>
          <el-button
            @click="applicationReview(scope.row)"
            type="text"
            size="small"
            v-if="operationArr.indexOf('applicationReview') !== -1"
          >审阅
          </el-button>
          <el-button
            @click="reportDownload(scope.row)"
            type="text"
            size="small"
            v-if="operationArr.indexOf('reportDownload') !== -1"
          >报表下载
          </el-button>
          <el-button
            @click="linkageConfig(scope.row)"
            type="text"
            size="small"
            v-if="operationArr.indexOf('linkageConfig') !== -1"
          >联动配置
          </el-button>
          <el-button
            @click="openRow(scope.row)"
            type="text"
            size="small"
            v-if="operationArr.indexOf('open') !== -1"
          >开启
          </el-button>
          <el-button
            @click="configLabel(scope.row)"
            type="text"
            size="small"
            v-if="operationArr.indexOf('configLabel') !== -1"
          >配置标签
          </el-button>
          <el-button
            @click="messageConfigRow(scope.row.code)"
            type="text"
            size="small"
            v-if="operationArr.indexOf('messageConfig') !== -1"
          >配置
          </el-button>
          <el-button
            @click="resetRow(scope.row.code)"
            type="text"
            size="small"
            v-if="operationArr.indexOf('reset') !== -1"
          >重置
          </el-button>
          <el-button
            @click="closeRow(scope.row)"
            class="electricUnApprove"
            type="text"
            size="small"
            v-if="operationArr.indexOf('close') !== -1"
          >关闭
          </el-button>
          <el-button
            @click="corporatePortrait(scope.row)"
            type="text"
            size="small"
            v-if="operationArr.indexOf('corporatePortrait') !== -1"
          >企业画像
          </el-button>
          <qr-popover-box
            style="margin-left:10px"
            v-if="operationArr.indexOf('qrPopBox') !== -1"
            title="请打开手机支付宝扫描"
            text="手机扫码授权"
            :content="scope.row.authUrl"/>
          <el-button
            @click="toAuthPage(scope.row.authUrl)"
            type="text"
            size="small"
            v-if="operationArr.indexOf('pcAuth') !== -1"
          >PC登录授权
          </el-button>
          <el-button
            @click="cancellationRow(scope.row)"
            type="text"
            size="small"
            v-if="operationArr.indexOf('cancellation') !== -1 && scope.row.status!=='7'"
          >作废
          </el-button>
          <el-button
            @click="orderForwardRow(scope.row)"
            type="text"
            size="small"
            v-if="operationArr.indexOf('orderForward') !== -1"
          >预订
          </el-button>
          <el-button
            @click="disorderForwardRow(scope.row)"
            type="text"
            size="small"
            v-if="operationArr.indexOf('disorderForward') !== -1&&scope.row.rentStatus==='4'"
          >取消预订
          </el-button>
          <el-button
            @click="refundRow(scope.row.code)"
            type="text"
            size="small"
            v-if="operationArr.indexOf('refund') !== -1 && new Date().getTime()<new Date(scope.row.enterEndDate).getTime()"
          >退费
          </el-button>
          <el-button
            @click="renewRow(scope.row.code)"
            type="text"
            size="small"
            v-if="operationArr.indexOf('renew') !== -1 && new Date().getTime()<new Date(scope.row.enterEndDate).getTime()+24 * 60 * 60 * 1000"
          >续费
          </el-button>
          <el-button
            @click="confirmRefundRow(scope.row)"
            type="text"
            size="small"
            v-if="operationArr.indexOf('confirmRefund') !== -1 && scope.row.actualRefundAmount==='--'"
          >确认退款
          </el-button>
          <span
            v-if="operationArr.indexOf('confirmRefund') !== -1 && scope.row.actualRefundAmount!='--'"
          >已退款
                </span>
          <el-button
            @click="confirmRefundFinanceRow(scope.row)"
            type="text"
            size="small"
            v-if="operationArr.indexOf('confirmRefundFinance') !== -1 && scope.row.status === '0'"
          >确认退款
          </el-button>
          <span
            v-if="operationArr.indexOf('confirmRefundFinance') !== -1 && scope.row.status !== '0'"
          >已退款
                </span>
          <el-button
            @click="relatedBillsRow(scope.row)"
            type="text"
            size="small"
            v-if="operationArr.indexOf('relatedBills') !== -1 && scope.row.bills.length === 0"
          >关联账单
          </el-button>
          <el-button
            @click="currentRow(scope.row.code)"
            type="text"
            size="small"
            v-if="operationArr.indexOf('relatedBills') !== -1 && scope.row.bills.length !== 0"
          >查看
          </el-button>
          <el-button
            @click="deleteBillRow(scope.row)"
            type="text"
            size="small"
            v-if="operationArr.indexOf('deleteBill') !== -1 && scope.row.bills.length === 0"
          >删除
          </el-button>
          <el-button
            @click="makeInvoiceRow(scope.row)"
            type="text"
            size="small"
            v-if="operationArr.indexOf('makeInvoice') !== -1"
          >开票
          </el-button>
          <el-button
            @click="ordinaryInvoiceRow(scope.row)"
            type="text"
            size="small"
            v-if="operationArr.indexOf('ordinaryInvoice') !== -1 && scope.row.allowOrdinary === 'allow'"
          >红冲
          </el-button>
          <el-button
            @click="hongChongInvoiceRow(scope.row)"
            type="text"
            size="small"
            v-if="operationArr.indexOf('hongChongInvoice') !== -1 && scope.row.allowHongchong === 'allow'"
          >红冲申请
          </el-button>
          <el-button
            @click="reopenInvoiceRow(scope.row)"
            type="text"
            size="small"
            v-if="operationArr.indexOf('allowReopen') !== -1 && scope.row.allowReopen === 'allow'"
          >重新开票
          </el-button>
          <el-button
            @click="invalidInvoiceRow(scope.row)"
            type="text"
            size="small"
            v-if="operationArr.indexOf('invalidInvoice') !== -1 && scope.row.allowInvalid === 'allow'"
          >作废
          </el-button>
          <el-button
            @click="reprintRow(scope.row)"
            type="text"
            size="small"
            v-if="operationArr.indexOf('reprint') !== -1"
          >重新打印
          </el-button>
          <el-button
            @click="moveOutRow(scope.row)"
            type="text"
            size="small"
            v-if="operationArr.indexOf('moveOut') !== -1 && scope.row['moveStatus'] === '0'"
          >迁出
          </el-button>
          <el-button
            v-if="operationArr.indexOf('cancelReservation') !== -1 && scope.row['orderCanceled'] != 1"
            @click="cancelReservationRow(scope.row)"
            type="text"
            size="small"
          >取消预约
          </el-button>
          <div v-if="operationArr.indexOf('cancelReservation') !== -1 && scope.row['orderCanceled'] === 1">已取消</div>
          <el-button
            @click="checkIn(scope.row)"
            type="text"
            size="small"
            v-if="operationArr.indexOf('checkIn') !== -1"
          >办理入住
          </el-button>
          <el-button
            v-if="operationArr.indexOf('checkOut') !== -1"
            @click="checkOut(scope.row)"
            type="text"
            size="small"
          >退房
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20, 50, 100]"
      :current-page="pageNum"
      :page-size="pageSize"
      v-if="pagination"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>


    <el-dialog
      title="通知单模板选择"
      :visible.sync="noticeDialogFormVisible"
      width="500px"
      class="contractDialogForm"
      v-loading="downloadNoticeLoading"
      element-loading-text="通知单生成中，请耐心等待"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)">
      <div>
        <div
          v-for="item in noticeTemplateList"
          class="contractDialogLine"
          :key="item.templateName">
          <div>{{ item.templateName }}</div>
          <div class="operationBox">
            <span
              style="margin-right: 20px;"
              @click="previewContract(item.path, item.fileName, item.code)"
            >预览
            </span>
            <span @click="downloadContract(item.path, item.fileName, item.code)">下载</span>
          </div>
        </div>
        <div
          v-if="noticeTemplateList.length === 0"
          style="text-align: center;line-height: 30px;"
        >暂无通知单模板
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import QrPopoverBox from '../QR/qr-popover-box'
import {nAlert, nError, nSuccess, nWarn} from '../../utils/notice'
import {bus} from '../../utils/bus'
import {errorHandler} from '../../utils/errorHandler'
import {api} from '../../view/api/Finance'
import ButtonConfirm from '../Button/ButtonConfirm'

export default {
  components: {ButtonConfirm, QrPopoverBox},
  name: 'table-main',
  props: {
    autoUpload: {
      type: Boolean,
      default: false
    },
    uploadSignPerson: Boolean,
    cathUrl: String,
    onSuccess: {
      type: Function,
      default (data) {
        const e = errorHandler('导入失败')(data)
        if (!(e instanceof Error)) {
          nSuccess('导入成功')
        }
      }
    },
    tableWidth: {
      type: String,
      default: '100%'
    },
    tableHeight: {
      type: Number,
      default () {
        return 618
      }
    },
    selection: {
      type: Boolean,
      default: true
    },
    tableHead: {
      type: Array
    },
    tableOperationWidth: {
      type: String
    },
    hasOperation: {
      type: Boolean,
      default: true
    },
    operationArr: {
      type: Array,
      default () {
        return ['current', 'delete']
      }
    },
    tableData: {
      type: Array,
      default () {
        return []
      }
    },
    relTableSelectData: {
      type: Array,
      default () {
        return []
      }
    },
    total: {
      type: Number,
      default: 0
    },
    pageNum: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 10
    },
    rowClick: {
      type: Function,
      default () {
      }
    },
    rowDblclick: {
      type: Function,
      default () {
      }
    },
    deleteTipInfo: {
      type: String,
      default: '是否确认删除该行数据？'
    },
    actionUrl: {
      type: String,
      default: ''
    },
    pagination: {
      type: Boolean,
      default: true
    },
    operationFixed: {
      type: [String, Boolean],
      default () {
        return false
      }
    },
    noticeUrl: {
      type: String,
      default: ''
    },
    noticeType: {
      type: String,
      default: '1'
    }
  },
  data () {
    return {
      relTableData: [],
      QRText: '手机扫码授权',
      QRTitle: '打开支付宝扫描',
      content: '',
      action: '',
      currentFileName: '',
      upLoadHeader: {},

      downloadNoticeLoading: false,
      noticeDialogFormVisible: false,
      noticeTemplateList: [],
      currentDueOverData: {},
      changeDownloadOrUpdateFileRow: ''
    }
  },
  created () {
    this.upLoadHeader.token = bus.global.token
    this.upLoadHeader['yq-app-code'] = bus.global.yqCode
  },
  mounted () {
    this.relTableData = this.tableData
    if (this.relTableData.length > 0) {
      this.relTableData.map(v => {
        for (let i in v) {
          if (v[i] !== 0) {
            if (!v[i] && i !== 'invoiceNo' && i !== 'pushBalance') {
              v[i] = '--'
            }
          }
        }
      })
      this.$nextTick(() => {
        this.relTableData.map((v, idx) => {
          this.relTableSelectData.forEach(selectCode => {
            if (selectCode === v.code) {
              console.log(selectCode)
              console.log(this.relTableData[idx])
              this.$refs.multipleTable.toggleRowSelection(
                this.relTableData[idx],
                true
              )
            }
          })
        })
      })
    }
  },
  methods: {
    handleSizeChange (val) {
      this.$emit('changePagination', [this.pageNum, val])
    },
    handleCurrentChange (val) {
      this.$emit('changePagination', [val, this.pageSize])
    },
    selectionChange (selection) {
      console.log(selection)
      let arr = []
      selection.map(v => {
        arr.push(v.code)
      })
      console.log(this.relTableSelectData)
      if (this.relTableSelectData) {
        this.relTableSelectData.map(v => {
          if (arr.indexOf(v) === -1) {
            arr.push(v)
          }
        })
      }
      this.$emit('changeSelection', arr)
    },
    modifyListingsRow (row) {
      this.$emit('modifyListings', row)
    },
    deleteListingRow (row) {
      this.$emit('deleteListings', row)
    },
    lookOver (row) {
      this.$emit('lookOver', row)
    },
    changeDownloadOrUpdateFile (row) {
      this.changeDownloadOrUpdateFileRow = row
    },
    uploadContractSuccess (res) {
      this.$emit(
        'uploadContractSuccess',
        res,
        this.changeDownloadOrUpdateFileRow
      )
    },
    // 上传失败
    uploadContractError (err) {
      nError('上传失败')
    },
    uploadEnclosureSuccess (res) {
      this.$emit(
        'uploadEnclosureSuccess',
        res,
        this.changeDownloadOrUpdateFileRow
      )
    },
    // 上传失败
    uploadEnclosureError (err) {
      nError('上传失败')
    },
    downloadOrUpdateFile (row) {
      this.$emit('downloadOrUpdateFile', row)
    },
    downloadOrUpdateEnclosureFile (row) {
      this.$emit('downloadOrUpdateEnclosureFile', row)
    },
    downloadAppendix (row) {
      this.$emit('downloadAppendix', row)
    },
    closeInventory (row) {
      this.$emit('closeInventory', row)
    },
    closeQuestionnaire (row) {
      this.$emit('closeQuestionnaire', row)
    },
    lookOverImg (img) {
      this.$emit('lookOverImg', img)
    },
    exhibition (data, str) {
      this.$emit('exhibition', data, str)
    },
    lookOver2 (img) {
      this.$emit('lookOver2', img)
    },
    currentRow (code) {
      console.log(code, 'code')
      window.sessionStorage.setItem('pageNum', this.pageNum)
      window.sessionStorage.setItem('pageSize', this.pageSize)
      this.$emit('toCurrentPage', code)
    },
    getTemporaryQRCode (data) {
      this.$emit('getTemporaryQRCode', data)
    },
    getUnlicensedQRCode (data) {
      this.$emit('getUnlicensedQRCode', data)
    },
    incubationAgreementRow (data) {
      this.$emit('toIncubationAgreementPage', data)
    },
    incubatorProjectRow (data) {
      this.$emit('toIncubatorProjectPage', data)
    },
    cancellationRow (data) {
      this.$emit('cancellation', data)
    },
    unbindRoomRow (code) {
      this.$emit('unbindRoomRow', code)
    },
    detailsRow (data) {
      window.sessionStorage.setItem('pageNum', this.pageNum)
      window.sessionStorage.setItem('pageSize', this.pageSize)
      this.$emit('toDetailsPage', data)
    },
    modifyRow (code) {
      window.sessionStorage.setItem('pageNum', this.pageNum)
      window.sessionStorage.setItem('pageSize', this.pageSize)
      this.$emit('goToModifyPage', code)
    },
    updateMemoRow (code) {
      window.sessionStorage.setItem('pageNum', this.pageNum)
      window.sessionStorage.setItem('pageSize', this.pageSize)
      this.$emit('goToUpdateMemoPage', code)
    },
    messageConfigRow (code) {
      this.$emit('goToMessageConfig', code)
    },
    resetRow (code) {
      this.$emit('resetRow', code)
    },
    schedulingRow (data) {
      this.$emit('schedulingRow', data)
    },
    settlementRow (data) {
      this.$emit('settlementRow', data)
    },
    PCAuth (url) {
      window.open(url)
    },
    deleteRow (code) {
      this.$confirm(this.deleteTipInfo, '温馨提示', {
        type: 'warning'
      })
        .then(() => {
          this.$emit('deleteLine', [code])
        })
        .catch(() => {
          console.log('取消删除')
        })
    },
    getAmmeterTip (data) {
      this.$emit('getAmmeterTip', data)
    },
    getDeviceCodeTip (data) {
      this.$emit('getDeviceCodeTip', data)
    },
    separateAccountsRow (data) {
      this.$emit('separateAccounts', data)
    },
    importBill (data) {
      this.$emit('importBill', data)
    },
    nullifyRow (data) {
      this.$emit('nullifyRow', data)
    },
    approveRow (data) {
      this.$emit('approveLine', data)
    },
    electricApproveRow (data) {
      this.$emit('electricApproveRow', data)
    },
    unApproveRow (code) {
      this.$emit('unApproveLine', code)
    },
    saveCopyContractRow (data) {
      this.$emit('saveCopyContractRow', data)
    },
    manualProcessingRow (data) {
      this.$emit('manualProcessingRow', data)
    },
    electricUnApproveRow (data) {
      this.$emit('electricUnApproveRow', data)
    },
    visitView (code) {
      this.$emit('visitView', code)
    },
    previewRow (code) {
      this.$emit('previewRow', code)
    },
    downloadRow (code) {
      this.$emit('downloadRow', code)
    },
    changeSwitch (data) {
      this.$emit('changeSwitch', data)
    },
    changeSwitch2 (data) {
      this.$emit('changeSwitch2', data)
    },
    modifyLock (data) {
      this.$emit('modifyLock', data)
    },
    modifyInvoiceStatus (data) {
      this.$emit('modifyInvoiceStatus', data)
    },
    statusChange (data) {
      this.$emit('statusChange', data)
    },
    statusInfoChange (data) {
      this.$emit('statusInfoChange', data)
    },
    changeInputChange (data, key) {
      this.$emit('changeInputChange', data, key)
    },
    wantChangeInput (data, key) {
      this.$emit('wantChangeInput', data, key)
    },
    invoiceRecordRow (serialNo) {
      this.$emit('invoiceRecordRow', serialNo)
    },
    ordinaryInvoiceRow (data) {
      this.$emit('ordinaryInvoiceRow', data)
    },
    hongChongInvoiceRow (data) {
      this.$emit('hongChongInvoiceRow', data)
    },
    reopenInvoiceRow (data) {
      this.$emit('reopenInvoiceRow', data)
    },
    invalidInvoiceRow (data) {
      this.$emit('invalidInvoiceRow', data)
    },
    reprintRow (data) {
      this.$emit('reprintRow', data)
    },
    faceAuthorizationRow (data) {
      this.$emit('faceAuthorizationRow', data)
    },
    invoiceDetailRow(serialNo) {
      this.$emit('invoiceDetailRow', serialNo)
    },
    synchronousRow(data) {
      this.$emit('synchronousRow', [data])
    },
    syncInvoiceRow (data) {
      this.$emit('syncInvoiceRow', [data])
    },
    issueReceiptRow (data) {
      this.$emit('issueReceiptRow', data)
    },
    sendMessageRow (data) {
      this.$emit('sendMessage', data)
    },
    seeExample (data) {
      this.$emit('seeExample', data)
    },
    onExceed (files, fileList) {
      nWarn(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，
        共选择了 ${files.length + fileList.length} 个文件`
      )
    },
    beforeUpload (file) {
      console.log(file)
      // const office2003 = 'application/vnd.ms-excel'
      // const office2007 =
      //   'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      // if (file.type === office2007) {
      //   return true
      // }
      // if (file.type === office2003) {
      //   return true
      // }
      // nAlert('暂不支持改格式的文件，请前往右上角帮助与支持下载对应模板')
      // return false
    },
    uploaderror (err) {
      if (JSON.parse(err.message).data) {
        let url = JSON.parse(err.message).data
        if (url) {
          let eleLink = document.createElement('a')
          eleLink.download = '未导入数据.xls'
          eleLink.style.display = 'none'

          eleLink.href = url

          document.body.appendChild(eleLink)
          eleLink.click()
          // 然后移除
          document.body.removeChild(eleLink)
          // this.$layer.toast({
          //   icon: 'icon-check',
          //   content: errorMessage(+JSON.parse(err.message).data),
          //   time: 1000
          // })
        }
      } else {
        this.$layer.toast({
          icon: 'icon-check',
          content: '导入出错',
          time: 1000
        })
      }
    },
    chageSign (row) {
      this.currentFileName = row.code
      this.action = this.cathUrl
      this.upLoadHeader['itemCode'] = row.code
      // let timestamp = new Date().getTime()
      // let mainUrl = this.cathUrl
      // let newCathUrl = mainUrl.split('?')[0]
      // this.action = newCathUrl + '&timestamp=' + timestamp
      // let pUrl = newCathUrl.split('/ecard')[1].split('?')[0]
      // let allowToken = `url=/ecard${pUrl}&timestamp=${timestamp}&key=WLXXPBDBVDZYONRQW7P9XRTJFI1NXCKA`
      // let accessToken = md5(allowToken)
      // this.upLoadHeader = {
      //   'sign': accessToken
      // }
    },

    // 预览
    previewStream (data) {
      this.$emit('previewStream', data)
    },

    // 审阅
    applicationReview (data) {
      this.$emit('applicationReview', data)
    },

    reportDownload (data) {
      this.$emit('reportDownload', data)
    },

    // 联动配置
    linkageConfig (data) {
      this.$emit('linkageConfig', data)
    },

    openRow (data) {
      this.$emit('openRow', data)
    },

    configLabel (data) {
      this.$emit('configLabel', data)
    },

    publishRow (data) {
      this.$emit('publishRow', data)
    },

    closeRow (data) {
      this.$emit('closeRow', data)
    },

    corporatePortrait (data) {
      this.$emit('corporatePortrait', data)
    },

    toAuthPage (url) {
      window.open(url, '_blank')
    },

    // 选择催款单
    showNoticeChoose (data) {
      console.log(data)
      this.currentDueOverData = data
      this.noticeDialogFormVisible = true
      this.getTemplateList()
    },

    // 获取催款单列表
    getTemplateList () {
      this.$axios
        .post(api.getTemplateList, {
          templateType: this.noticeType
        })
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data
            this.noticeTemplateList = data
          }
        })
        .catch(errorHandler('获取催款单失败'))
    },

    // 催款单预览
    previewContract (path, fileName, code) {
      this.downloadNoticeLoading = true
      let url = ''
      if (this.noticeUrl) {
        url = this.noticeUrl
      } else {
        url = api.createLeaseUrl
      }
      this.$axios
        .post(url, {
          billCode: this.currentDueOverData.code,
          fileName: fileName,
          templateUrl: path,
          templateCode: code
        })
        .then(res => {
          this.downloadNoticeLoading = false
          if (res.data.retCode === 1) {
            let data = res.data.data
            if (data) {
              window.open(
                'http://view.officeapps.live.com/op/view.aspx?src=' + data,
                '_blank'
              )
            } else {
              nError('预览失败')
            }
          }
        })
        .catch(errorHandler('预览失败'))
        .then(() => {
          this.downloadNoticeLoading = false
        })
    },
    // 催款单生成并下载
    downloadContract (path, fileName, code) {
      this.downloadNoticeLoading = true
      let url = ''
      if (this.noticeUrl) {
        url = this.noticeUrl
      } else {
        url = api.createLeaseUrl
      }
      this.$axios
        .post(url, {
          billCode: this.currentDueOverData.code,
          fileName: fileName,
          templateUrl: path,
          templateCode: code
        })
        .then(res => {
          this.downloadNoticeLoading = false
          if (res.data.retCode === 1) {
            let data = res.data.data
            if (data) {
              window.open(data, '_blank')
            } else {
              nError('地址无效')
            }
          }
        })
        .catch(errorHandler('生成失败'))
        .then(() => {
          this.downloadNoticeLoading = false
        })
    },

    orderForwardRow (data) {
      this.$emit('orderForward', data)
    },
    disorderForwardRow (data) {
      this.$emit('disorderForward', data)
    },
    refundRow (data) {
      this.$emit('refund', data)
    },
    renewRow (data) {
      this.$emit('renew', data)
    },
    confirmRefundRow (data) {
      this.$emit('confirmRefund', data)
    },
    confirmRefundFinanceRow (data) {
      this.$emit('confirmRefundFinanceRow', data)
    },
    relatedBillsRow (data) {
      this.$emit('relatedBillsRow', data)
    },
    deleteBillRow (data) {
      this.$emit('deleteBillRow', data)
    },
    makeInvoiceRow (data) {
      this.$emit('makeInvoiceRow', data)
    },
    moveOutRow (data) {
      this.$emit('moveOut', data)
    },
    dataSummaryRow (data) {
      this.$emit('dataSummary', data)
    },
    viewInventoryListRow (data) {
      this.$emit('viewInventoryList', data)
    },
    viewInventoryReportRow (data) {
      this.$emit('viewInventoryReport', data)
    },
    cancelReservationRow (data) {
      this.$emit('cancelReservation', data)
    },
    checkIn (data) {
      this.$emit('checkIn', data)
    },
    checkOut (data) {
      this.$emit('checkOut', data)
    },
    quickReportRow (data) {
      this.$emit('quickReport', data)
    },
    queryStateRow (data) {
      this.$emit('queryState', data)
    },
    GenerateReportRow (data) {
      this.$emit('GenerateReport', data)
    },
    allocateListings (data) {
      this.$emit('allocateListings', data)
    }
  },
  watch: {
    tableData () {
      this.relTableData = this.tableData
      if (this.relTableData.length > 0) {
        this.relTableData.map((v, idx) => {
          for (let i in v) {
            if (v[i] !== 0) {
              if (!v[i] && i !== 'invoiceNo' && i !== 'pushBalance') {
                v[i] = '--'
              }
            }
          }
        })
        this.$nextTick(() => {
          this.relTableData.map((v, idx) => {
            this.relTableSelectData.forEach(selectCode => {
              if (selectCode === v.code) {
                console.log(selectCode)
                console.log(this.relTableData[idx])
                this.$refs.multipleTable.toggleRowSelection(
                  this.relTableData[idx],
                  true
                )
              }
            })
          })
        })
      }
    },
    uploadSignPerson (v) {
      // console.log(this.$refs)
      if (v === true) {
        console.log(this.$refs)
        this.$refs.uploadSign.submit()
      }
    }
  }
}
</script>

<style lang="less">
.all-table-class {
  margin-bottom: 20px;

  .el-table {
    .housing-allocation-box {
      width: 94%;
      padding: 10px;
      margin: 10px auto 20px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);

      .housing-allocation-box-top {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin: 0 16px 5px;
      }

      .housing-allocation-line {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;

        .housing-allocation-item {
          width: 208px;
          height: 131px;
          margin: 20px 16px;
          background: rgba(255, 255, 255, 0.39);
          box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
          border-radius: 8px;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;

          .housing-allocation-item-title {
            width: 208px;
            height: 40px;
            padding: 0 4px;
            background: rgba(239, 242, 255, 0.39);
            border-radius: 8px 8px 0px 0px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .housing-allocation-item-label {
              flex: 1;
              font-size: 16px;
              font-weight: 500;
              line-height: 40px;
              color: #333333;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .housing-allocation-item-area {
              font-size: 14px;
              font-weight: 400;
              line-height: 40px;
              color: #333333;

              i {
                cursor: pointer;
              }
            }
          }

          .housing-allocation-item-info {
            flex: 1;
            padding: 8px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            .housing-allocation-item-info-line {
              flex: 1;
              display: flex;
              justify-content: flex-start;
              align-items: center;

              i {
                margin-right: 10px;
              }

              .housing-allocation-item-info-line-main {
                flex: 1;
                font-size: 12px;
                font-weight: 400;
                color: #333333;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
          }
        }
      }
    }
  }

  .el-table thead {
    color: #48576a;
  }

  .el-table::before {
    height: 0;
  }

  .el-table .el-table__header tr {
    background-color: #eff1f5;

    th {
      padding: 10px 0;
      background-color: #eff1f5;
    }
  }

  .el-table .cell {
    font-size: 13px;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    //display: flex;
    //justify-content:center;
    //align-items: center;
  }

  .el-table .cell div {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    .el-switch__label {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;

      span {
        font-size: 14px;
      }
    }
  }

  .el-button--text {
    color: #1362ff;
    font-size: 14px;
    margin-left: 10px;

    :hover {
      color: #06b3ff;
    }
  }

  .electricUnApprove {
    color: #b22222 !important;

    :hover {
      color: #ff2f28 !important;
    }
  }

  .el-table td {
    padding: 7px 0;
  }

  tbody {
    overflow: scroll;
  }

  .el-pagination {
    height: 32px;
    line-height: 32px;
    margin-top: 15px;

    .el-pagination__total, .btn-prev, .btn-next, .number, .more, .el-pagination__jump {
      height: 32px;
      line-height: 32px;
      font-size: 14px;
    }

    .el-pagination__sizes {
      .el-select--mini {
        width: 100px;
      }

      .el-input__inner {
        width: 100px;
        height: 32px;
        line-height: 32px;
        font-size: 14px;
      }
    }

    .el-input__inner {
      height: 32px;
      line-height: 32px;
      font-size: 14px;
    }
  }

  .contractDialogForm {
    .el-dialog__header {
      text-align: center;
    }

    .operationBox {
      span {
        cursor: pointer;
        color: #337ab7;
      }

      span:hover {
        color: #1362ff;
      }
    }

    .contractDialogLine {
      display: flex;
      justify-content: space-between;
      margin-bottom: 15px;
      line-height: 30px;
      padding: 0 15px;
    }

    .contractDialogLine:hover {
      background-color: #eeeeee;
    }
  }

  .el-table__row--level-1 {
    color: #a0a0a0 !important;
  }

  /deep/ .el-table__row--level-1 {
    color: #a0a0a0;
  }

  ::-webkit-scrollbar {
    height: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Table/TableMain.vue